// extracted by mini-css-extract-plugin
module.exports = {"tip":"Tag_tip__yu2iV","icon":"Tag_icon__eXdRU","tagContent":"Tag_tagContent__sjVhs","tagDescription":"Tag_tagDescription__jPSuS"};